import { v4 as uuidv4 } from 'uuid';

export class LieferantDokumentUploadDto {
    constructor(datei: any) {
        this.datei = datei;
        this.dokumentTyp = 'archiv.dokumenttyp.lieferantendokument';
        this.titel = '';
        this.dokumentKategorie = '';
        this.teilnehmerId = '';
        this.uuid = uuidv4();
    }
    dokumentTyp: string;
    titel: string;
    dokumentKategorie: string;
    teilnehmerId: string;
    uuid: string;
    datei: File;
}
